/* eslint-disable camelcase */

import {
  Column, CreateDateColumn,
  Entity,
  JoinColumn,
  ManyToOne,
  PrimaryGeneratedColumn, UpdateDateColumn
} from "typeorm";
import { Hardware } from "./reg_hardwares.entity";
import { User } from "./reg_users.entity";
import { WaterFactorSourceType } from "../types/water_factor_source_type.enum";

@Entity("reg_hardware_water_factor_versions")
export class HardwareWaterFactorVersion {

  @PrimaryGeneratedColumn("uuid")
    id_hardware_water_factor_version?: string;

  @CreateDateColumn({ default: "(now() at time zone 'utc')" })
    registration_date?: Date;

  @UpdateDateColumn({ default: "(now() at time zone 'utc')" })
    updated_date?: Date;

  @ManyToOne(() => Hardware, (hardware) => hardware.water_factor_versions, { onDelete: "CASCADE", nullable: false })
  @JoinColumn({ name: "id_hardware_fk" })
    hardware?: Hardware;

  @ManyToOne(() => User, (user) => user.water_factor_versions, { onDelete: "RESTRICT", nullable: false })
  @JoinColumn({ name: "id_user_fk" })
    user?: User;

  @Column({
    type: "numeric",
    precision: 3,
    scale: 2,
    nullable: false,
    default: 1.00,
    transformer: { to: (value) => value, from: (value) => parseFloat(value) }
  })
    water_correction_factor?: number;

  @Column({
    type: "numeric",
    precision: 3,
    scale: 2,
    nullable: true,
    transformer: { to: (value) => value, from: (value) => (value !== null ? parseFloat(value) : null) }
  })
    previous_water_correction_factor?: number;

  @Column({ type: "boolean", nullable: false, default: false })
    active?: boolean;

  @Column({ type: "enum", enum: WaterFactorSourceType, nullable: false, default: WaterFactorSourceType.MANUAL })
    source?: string;

}
